import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';

import { getNav4OptOutCache, getNav4GAOptInCache } from './useNav4OptOut';
import { getNav4GAPhase } from './getNav4GAPhase';
import { getNav4AdminOptInCache } from './nav4AdminOptInCache';

/**
 * YOU SHOULD PROBABLY CALL `useIsNav4Enabled` INSTEAD OF THIS FUNCTION.
 * Please check with #cc-disco before using.
 */

/**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              useIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/
// eslint-disable-next-line confluence-feature-gating/inline-usage
export const getIsNav4Enabled = () => {
	const currentGAPhase = getNav4GAPhase();
	const nav4AdminOptedIn = getNav4AdminOptInCache();

	if (currentGAPhase === 2) {
		return true;
	}

	if (getNav4OptOutCache()) {
		if (
			currentGAPhase === 1 && //if we're in phase 1
			nav4AdminOptedIn && //and the whole product is opted into nav4
			!fg('confluence_nav_4_phase_1_opt_out')
		) {
			//and two way door is not enabled
			return true; //ignore user's opt out status and show nav4
		}
		return false;
	}

	return (
		fg('confluence_nav_4') ||
		expVal('confluence_jira_nav4_new_customers', 'willShowNav4', false) ||
		expVal('confluence_nav_4_free', 'isEnabled', false) ||
		(currentGAPhase === 1 && (getNav4AdminOptInCache() || getNav4GAOptInCache())) //checks both site opt-in and admin only opt-in
	);
};
